module.exports = __webpack_public_path__ + "img/med1.025eb2d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/med1.png
// module id = I3Dh
// module chunks = 0